import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { href: "#flotta", label: "Flotta", testid: "nav-link-flotta" },
  { href: "#servizi", label: "Servizi", testid: "nav-link-servizi" },
  { href: "#perche-noi", label: "Perché Noi", testid: "nav-link-perche-noi" },
  { href: "#preventivo", label: "Preventivo", testid: "nav-link-preventivo" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="bg-slate-900 text-white" data-testid="top-phone-bar">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-10 flex items-center justify-between gap-4">
          <p className="hidden sm:flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.22em] text-slate-300">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            Operatore diretto — assistenza &amp; prenotazioni
          </p>
          <a
            href="tel:+393773899146"
            data-testid="top-bar-phone-link"
            className="flex items-center gap-2 text-sm font-semibold text-emerald-400 hover:text-emerald-300 transition-colors duration-300 mx-auto sm:mx-0"
          >
            <Phone className="w-3.5 h-3.5" />
            +39 377 389 9146
          </a>
        </div>
      </div>

      <nav className="backdrop-blur-xl bg-white/80 border-b border-slate-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <a href="#top" data-testid="nav-logo" aria-label="Noleggio Sicuro home">
            <Logo />
          </a>
          <div className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testid}
                className="text-sm font-medium text-slate-600 hover:text-emerald-700 transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+393773899146"
              data-testid="nav-phone-button"
              className="inline-flex items-center gap-2 rounded-full bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-700 hover:text-white transition-colors duration-300"
            >
              <Phone className="w-4 h-4" />
              Chiama ora
            </a>
          </div>
          <button
            className="md:hidden p-2 text-slate-700"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {open && (
          <div className="md:hidden border-t border-slate-200 bg-white px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-slate-700 hover:text-emerald-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+393773899146"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-600 px-5 py-3 text-sm font-semibold text-white"
            >
              <Phone className="w-4 h-4" />
              +39 377 389 9146
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};
